import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../utils/format';

function fmtMins(totalMins) {
  const h = Math.floor(totalMins / 60);
  const m = totalMins % 60;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}

function TotalsStrip({
  totalMinutes,
  totalCostSmallestUnit,
  emptyCellCount,
  offCellCount,
  currency,
  saveStatus,
}) {
  const { t } = useTranslation('scheduler');

  const costFormatted =
    totalCostSmallestUnit > 0
      ? formatCurrency(totalCostSmallestUnit / 100)
      : null;

  return (
    <div className="flex items-center gap-8 px-6 py-4 border-t border-gray-200 bg-white rounded-b-xl flex-wrap gap-y-2">
      {/* Primary stat: hours */}
      <div className="flex flex-col">
        <span className="text-xs font-medium uppercase tracking-wide text-gray-500">
          {t('totals.totalHoursLabel')}
        </span>
        <span className="text-xl font-semibold text-gray-900 mt-0.5">
          {fmtMins(totalMinutes)}
        </span>
      </div>

      {/* Primary stat: cost */}
      {costFormatted && (
        <div className="flex flex-col">
          <span className="text-xs font-medium uppercase tracking-wide text-gray-500">
            {t('totals.estLaborCostLabel')}
          </span>
          <span className="text-xl font-semibold text-gray-900 mt-0.5">
            {costFormatted}
          </span>
        </div>
      )}

      {/* Secondary stats */}
      <div className="flex items-center gap-4 text-sm text-gray-500 ml-auto flex-wrap">
        <span>
          {t('totals.emptyCells', { count: emptyCellCount })}
        </span>
        <span>
          {t('totals.offCells', { count: offCellCount })}
        </span>
        {saveStatus && (
          <span className={`font-medium ${saveStatus.color}`}>
            {saveStatus.text}
          </span>
        )}
      </div>
    </div>
  );
}

export default TotalsStrip;